//
//  I00RELGAZPUISSI18n.js
//
//  Created by Sébastien Hecart on 2017-11-21 16:43:31 +0000.
//  Copyright © 2017 Sebastien Hecart. All rights reserved.
//

export default {
  I00RELGAZPUISS_SECTION_0_TITLE: "Calculez la puissance d'une chaudière.",
  I00RELGAZPUISS_in_pci: 'PCI',
  I00RELGAZPUISS_in_pressionGaz: 'Pression gaz',
  I00RELGAZPUISS_in_debitCompteur: 'Débit compteur',
  I00RELGAZPUISS_in_temperatureGaz: 'Température gaz',
  I00RELGAZPUISS_in_pressionAtmospherique: 'Pression atmosphérique',
  I00RELGAZPUISS_SECTION_1_TITLE: '',
  I00RELGAZPUISS_res_puisanceChaudiere: 'Puissance chaudière'
}
